import * as React from 'react';

import {classify} from 'src/utils/index';
import {ClickAway} from '@spaced-out/ui-design-system/lib/utils/click-away';
import {FilterButton} from 'src/components/lib/analytics-filter-button/index';
import {FilterCard} from 'src/components/lib/analytics-filter-card/index';

import css from './index.css';


export function FilterDropdown({
  text,
  header,
  solid,
  children,
  direction = 'right',
}: {
  text: string;
  header: string;
  solid?: unknown;
  children: React.ReactNode;
  direction?: 'left' | 'right';
}) {
  return (
    <ClickAway>
      {({isOpen, onOpen, triggerRef, boundaryRef}) => (
        <div className={css.filter}>
          {/* @ts-expect-error - TS2322 - Type 'TriggerRefType<HTMLElement | null | undefined>' is not assignable to type 'Ref<HTMLDivElement> | undefined'. */}
          <div ref={triggerRef}>
            <FilterButton
              className={css.button}
              // @ts-expect-error - TS2769 - No overload matches this call.
              active={solid}
              onClick={onOpen}
            >
              {text}
            </FilterButton>
          </div>
          {isOpen && (
            <div
              className={classify(css.filterCard, {
                [css.left]: direction === 'left',
              })}
              // @ts-expect-error - TS2322 - Type 'BoundaryRefType<HTMLElement | null | undefined>' is not assignable to type 'Ref<HTMLDivElement> | undefined'.
              ref={boundaryRef}
            >
              <FilterCard header={header}>
                <div className={css.filterContent}>{children}</div>
              </FilterCard>
            </div>
          )}
        </div>
      )}
    </ClickAway>
  );
}

export function FilterField({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className={css.field}>
      <div className={css.label}>{label}</div>
      {children}
    </div>
  );
}
